import localStore from 'store';
import PreferencePatterns from '../constants/PreferencePatterns';
import RegexPatterns from '../constants/regexPatterns';

const innerRuleSetZIndex = (i, refId, ir) => {
  const preference = localStore.get('preference');
  let index = i;

  for (let k = 0; k < ir.items.length; k += 1) {
    const item = ir.items[k];
    index += 1;

    if (item === refId) {
      return { index, found: true };
    }

    const innerRuleSet = preference.innerRuleSetList.find(
      innerRule => innerRule.uid === item
    );

    if (typeof innerRuleSet !== 'undefined') {
      const res = innerRuleSetZIndex(index, refId, innerRuleSet);
      index += res.index;

      if (res.found) {
        return { index, found: true };
      }
    }
  }
  return { index, found: false };
};

const preferenceZIndex = refId => {
  const preference = localStore.get('preference');
  let index = 0;
  let a = 0;

  for (let i = 0; i < preference.ruleSetList.length; i += 1) {
    const ruleSet = preference.ruleSetList[i];
    index += 1;
    a += 100;

    if (ruleSet.uid === refId) {
      return index + a;
    }

    for (let j = 0; j < ruleSet.items.length; j += 1) {
      const item = ruleSet.items[j];

      index += 1;
      if (item === refId) {
        return index + a;
      }

      const innerRuleSet = preference.innerRuleSetList.find(
        innerRule => innerRule.uid === item
      );

      if (typeof innerRuleSet !== 'undefined') {
        const res = innerRuleSetZIndex(index, refId, innerRuleSet);
        index += res.index;

        if (res.found) {
          return index + a;
        }
      }
    }
  }
  return index + a;
};

export const isValidFacts = (facts, ruleType) => {
  const factStr = facts.join('').trim();

  return (
    (PreferencePatterns.RULE_TYPE_FACTS_YES_NO_OPTION.includes(ruleType)
      && /^(yes|no)$/i.test(factStr))
    || (PreferencePatterns.RULE_TYPE_FACTS_NUMBER.includes(ruleType)
      && RegexPatterns.REGEX_NUMBER.test(factStr))
    || (PreferencePatterns.RULE_TYPE_FACTS_CHARACTER.includes(ruleType)
      && RegexPatterns.REGEX_CHARACTER.test(factStr))
    || (PreferencePatterns.RULE_TYPE_FACTS_CHARACTER_WITH_SPACE.includes(
      ruleType
    )
      && RegexPatterns.REGEX_CHARACTER_WITH_SPACE.test(factStr))
  );
};
export const returnErrMsg = ruleType => {
  return PreferencePatterns.RULE_TYPE_FACTS_NUMBER.includes(ruleType)
    ? PreferencePatterns.MSG_FACT_NUMBER
    : PreferencePatterns.RULE_TYPE_FACTS_CHARACTER.includes(ruleType)
      || PreferencePatterns.RULE_TYPE_FACTS_YES_NO_OPTION.includes(ruleType)
      ? PreferencePatterns.MSG_FACT_YES_NO_OPTION
      : PreferencePatterns.RULE_TYPE_FACTS_CHARACTER_WITH_SPACE.includes(ruleType)
        ? PreferencePatterns.MSG_FACT_CHARACTER
        : 'Please select Rule Type first.';
};

export default preferenceZIndex;
